import { createFileRoute } from "@tanstack/react-router";
import ProfesionalesRetail from "@/pages/ProfesionalesRetail";
import { SITE_URL } from "@/lib/site-url";

export const Route = createFileRoute("/en/retail-experts")({
  head: () => {
    const title = "Lawyers, licences, tax and shop works for retailers | Retail Lemon";
    const description =
      "Sara AI guides you; when it's time to sign or act, we connect you with retail specialists: leases, licences, employment, tax and shop works.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}/en/retail-experts` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_GB" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
    };
  },
  component: () => <ProfesionalesRetail routeLang="en" />,
});
